import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=85f0271a&scoped=true&"
import script from "./CalendarMonth.vue?vue&type=script&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&lang=js&"
import style0 from "./CalendarMonth.vue?vue&type=style&index=0&id=85f0271a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f0271a",
  null
  
)

export default component.exports